import { PreProcessor } from 'api/requestUtils'
import config from 'constants/config'
import { AppStore } from 'src/client/store'

export default function tokenLoader(store: AppStore): PreProcessor {
  return (params) => {
    if (params.options?.credentials === 'include') {
      const s = store.getState()
      if (
        config.ENDPOINT === params.endpoint &&
        s.auth.accessToken
      ) {
        params.options.headers = {
          ...params.options.headers,
          Authorization: `Bearer ${s.auth.accessToken}`,
        }
      }
    }
    return params
  }
}
